/* Frinta — "Suivre ma commande": asks the tracking worker and renders the 4-step timeline.
   Section: sections/frinta-page-track.liquid · worker: brand/storefront/track-worker (track.myfrinta.com). */
(function () {
  'use strict';
  var root = document.querySelector('[data-track]');
  if (!root) return;
  var form = root.querySelector('[data-track-form]');
  var i18n = {};
  try { i18n = JSON.parse(root.querySelector('[data-track-i18n]').textContent); } catch (e) { i18n = { ev: {} }; }
  var endpoint = root.getAttribute('data-endpoint');
  var locale = root.getAttribute('data-locale') || document.documentElement.lang || 'fr';
  var $ = function (sel, el) { return (el || root).querySelector(sel); };
  var result = $('[data-track-result]');
  var example = $('[data-track-example]');
  var alt = $('[data-track-alt]');
  var altLink = $('[data-track-fallback]');
  var errEl = $('[data-track-error]');
  var submit = $('[data-track-submit]');
  var busy = false;

  function fmt(iso, opts) {
    if (!iso) return '';
    var d = new Date(iso.length === 10 ? iso + 'T12:00:00Z' : iso);
    try { return new Intl.DateTimeFormat(locale, opts).format(d); } catch (e) { return d.toLocaleDateString(); }
  }
  var DAY = { weekday: 'short', day: 'numeric', month: 'short' };
  var SHORT = { day: 'numeric', month: 'short' };
  var FULL = { day: 'numeric', month: 'long', year: 'numeric' };
  var TIME = { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' };
  function tpl(s, vars) { return String(s || '').replace(/%([A-Z]+)%/g, function (_, k) { return vars[k] != null ? vars[k] : ''; }); }
  function evLabel(status) { return (i18n.ev && i18n.ev[status]) || i18n.step_3 || status; }

  function setError(msg, showFallback) {
    errEl.textContent = msg || '';
    errEl.hidden = !msg;
    if (showFallback) { altLink.textContent = i18n.app_cta || altLink.textContent; alt.classList.add('fr-track__alt--cta'); }
    alt.hidden = false;
  }
  function setBusy(on) {
    busy = on;
    submit.setAttribute('aria-busy', on ? 'true' : 'false');
    submit.textContent = on ? (i18n.loading || '…') : i18n.submit;
  }

  function render(d) {
    var o = d.order || {};
    var stage = d.stage;
    $('[data-track-name]').textContent = tpl(i18n.order_label, { NAME: o.name && o.name[0] !== '#' && /^\d/.test(o.name) ? '#' + o.name : (o.name || '') });
    $('[data-track-placed]').textContent = tpl(i18n.placed, { DATE: fmt(o.createdAt, FULL) });

    var pill = $('[data-track-pill]');
    var note = $('[data-track-note]');
    note.hidden = true; note.textContent = '';
    pill.className = 'fr-track__pill';
    if (stage === 0) {
      pill.textContent = i18n.cancelled; pill.classList.add('fr-track__pill--off');
      note.textContent = i18n.cancelled_sub; note.hidden = false;
    } else {
      pill.textContent = i18n['step_' + stage] || '';
      pill.classList.add('fr-track__pill--' + stage);
      if (o.financialStatus === 'REFUNDED') { pill.textContent = i18n.refunded; pill.className = 'fr-track__pill fr-track__pill--off'; }
    }

    var fl = d.fulfillments || [];
    var f = null;
    fl.forEach(function (x) { if (!f && (x.trackingNumber || x.trackingUrl)) f = x; });
    if (!f) f = fl[0] || null;
    var events = [];
    (d.fulfillments || []).forEach(function (x) { (x.events || []).forEach(function (e) { events.push(e); }); });
    events.sort(function (a, b) { return a.at < b.at ? -1 : 1; });
    var last = events.length ? events[events.length - 1] : null;
    var etaFrom = d.estimated ? d.estimated.from : null;
    var etaTo = d.estimated ? d.estimated.to : null;
    var etaText = etaFrom ? tpl(i18n.eta, { FROM: fmt(etaFrom, SHORT), TO: fmt(etaTo, SHORT) }) : '';
    var today = new Date().toISOString().slice(0, 10);

    var subs = ['', '', '', ''];
    subs[0] = fmt(o.createdAt, DAY);
    if (stage >= 2) subs[1] = tpl(i18n.shipped_sub, { DATE: fmt(d.shippedAt || (f && f.createdAt), DAY) });
    else if (stage === 1) subs[1] = i18n.preparing;
    if (stage >= 3) {
      var lastTransit = null;
      events.forEach(function (e) { if (e.status !== 'DELIVERED') lastTransit = e; });
      if (lastTransit) subs[2] = tpl(i18n.transit_sub, { DATE: fmt(lastTransit.at, DAY), STATUS: evLabel(lastTransit.status) });
      else if (stage < 4) subs[2] = f ? evLabel(f.status) : i18n.step_3;
      if (stage < 4 && etaText) subs[2] += (subs[2] ? ' · ' : '') + etaText;
    } else if (stage >= 1) subs[2] = etaText;
    if (stage === 4) subs[3] = tpl(i18n.delivered_sub, { DATE: fmt(d.deliveredAt || (last && last.at), DAY) });
    else subs[3] = i18n.step_4_sub || '';
    if (stage > 0 && stage < 4 && etaTo && etaTo < today) { note.textContent = i18n.eta_passed; note.hidden = false; }

    var steps = root.querySelectorAll('[data-track-steps] [data-step]');
    for (var i = 0; i < steps.length; i++) {
      var n = i + 1, cls = 'todo';
      if (stage > 0) { if (n < stage || stage === 4) cls = 'done'; else if (n === stage) cls = 'now'; }
      steps[i].className = 'fr-timeline__step fr-timeline__step--' + cls;
      $('[data-step-sub]', steps[i]).textContent = subs[i];
    }
    var fill = stage <= 1 ? 0 : stage === 2 ? 30 : stage === 3 ? 58 : 100;
    $('[data-track-steps]').style.setProperty('--fr-tl-fill', fill + '%');

    var carrier = $('[data-track-carrier]');
    var hasTracking = f && (f.trackingNumber || f.trackingUrl || f.carrier);
    carrier.hidden = !(hasTracking || events.length);
    $('[data-track-carrier-row]').hidden = !(f && f.carrier);
    $('[data-track-carrier-name]').textContent = f && f.carrier ? f.carrier : '';
    $('[data-track-number-row]').hidden = !(f && f.trackingNumber);
    $('[data-track-number]').textContent = f && f.trackingNumber ? f.trackingNumber : '';
    var url = $('[data-track-url]');
    url.hidden = !(f && f.trackingUrl);
    if (f && f.trackingUrl) url.href = f.trackingUrl;
    var hist = $('[data-track-history]');
    var list = $('[data-track-events]');
    list.innerHTML = '';
    hist.hidden = !events.length;
    events.slice().reverse().forEach(function (e) {
      var li = document.createElement('li');
      var t = document.createElement('time'); t.setAttribute('datetime', e.at); t.textContent = fmt(e.at, TIME);
      var s = document.createElement('span'); s.textContent = evLabel(e.status);
      li.appendChild(t); li.appendChild(s); list.appendChild(li);
    });

    result.hidden = false;
    if (example) example.hidden = true;
    alt.hidden = true;
    errEl.hidden = true;
    try { result.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
  }

  function lookup(order, email) {
    if (busy) return;
    order = String(order || '').trim();
    email = String(email || '').trim();
    if (!order || !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { setError(i18n.err_fields); return; }
    setBusy(true);
    errEl.hidden = true;
    var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 15000) : null;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order: order, email: email }),
      signal: ctrl ? ctrl.signal : undefined,
    }).then(function (r) {
      return r.json().then(function (j) { return { status: r.status, body: j }; }, function () { return { status: r.status, body: null }; });
    }).then(function (res) {
      if (res.status === 200 && res.body && res.body.order) { render(res.body); return; }
      if (res.status === 404 || res.status === 400) { result.hidden = true; if (example) example.hidden = false; setError(i18n.err_not_found, false); return; }
      if (res.status === 429) { setError(i18n.err_rate, false); return; }
      setError(i18n.err_generic, true);
    }).catch(function () {
      setError(i18n.err_generic, true);
    }).then(function () { if (timer) clearTimeout(timer); setBusy(false); });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    lookup(form.elements.order.value, form.elements.email.value);
  });
  $('[data-track-again]').addEventListener('click', function () {
    result.hidden = true;
    if (example) example.hidden = false;
    alt.hidden = false;
    form.elements.order.value = '';
    form.elements.email.value = '';
    try { form.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e) {}
    form.elements.order.focus();
  });

  // Links from e-mails: /pages/suivre-ma-commande?order=F1042S1 pre-fills the order; the customer types her e-mail
  // (the e-mail is never read from the URL).
  try {
    var qo = new URLSearchParams(location.search).get('order') || '';
    if (qo) { form.elements.order.value = qo.slice(0, 24); form.elements.email.focus(); }
  } catch (e) {}
})();
